export function isDebugEnabled(): boolean {
	try {
		const url = new URL(window.location.href);
		return url.searchParams.get("cheats") === "1";
	} catch {
		return false;
	}
}

let cachedDebugEnabled: boolean | null = null;

export function debugLog(...args: unknown[]): void {
	if (cachedDebugEnabled === null) {
		cachedDebugEnabled = isDebugEnabled();
	}

	if (!cachedDebugEnabled) return;
	console.log(...args);
}

export function debugWarn(...args: unknown[]): void {
	if (cachedDebugEnabled === null) {
		cachedDebugEnabled = isDebugEnabled();
	}

	if (!cachedDebugEnabled) return;
	console.warn(...args);
}

export function debugError(...args: unknown[]): void {
	if (cachedDebugEnabled === null) {
		cachedDebugEnabled = isDebugEnabled();
	}

	if (!cachedDebugEnabled) return;
	console.error(...args);
}
